import React, {useState, useCallback} from "react";
import PropTypes from "prop-types";
import Dialog from "components/dialog";
import withStyles from "components/with-styles";
import styles from "../styles/add-source-button.css.js";
import {ActionButton} from "components/buttons";
import {injectIntl} from "react-intl";
import {useMutation} from "@apollo/react-hooks";
import {createSubdeploymentMutation} from "./index";
import {useParams} from "react-router-dom";

import SubdeploymentForm from "./subdeployment-form";

const AddSubdeploymentButton = ({ intl, refetch, classes}) => {
    const {id} = useParams();
    const [createSubdeployment] = useMutation(createSubdeploymentMutation);
    const [open, setOpen] = useState(false);

    const handleOpen = useCallback(e => {
        setOpen(true);
        e.stopPropagation();
    }, []);

    const handleClose = useCallback(e => {
        setOpen(false);
        e.stopPropagation();
    }, []);

    const onSuccess = () => {
        setOpen(false);
        refetch();
    };

    return (
        <>
            <ActionButton icon="add" onClick={handleOpen}/>
            <Dialog
                title={intl.formatMessage({id: "app.page.deployment.details.addSubdeployment"})}
                open={open}
                fixed>
                <SubdeploymentForm edit={false} query={createSubdeployment} intl={intl} id={id} handleClose={handleClose} onSuccess={onSuccess} classes={classes}/>
            </Dialog>
        </>
    );
};

AddSubdeploymentButton.propTypes = {
    /**
     * Id de deployment al que se va a asociar
     **/
    deploymentId: PropTypes.string,
    /**
     * Indica si se muestra como un botón de acción
     **/
    actionButton: PropTypes.bool,
    /**
     * Callback que se invoca cuando se agrega la source al deployment
     */
    onSuccess: PropTypes.func.isRequired,
};

export default withStyles(styles)(injectIntl(AddSubdeploymentButton));
